import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../../context-role-element';

export default {
  [CONTEXT.VERIFY_PAGE]: {
    [ROLE.FORM]: [ELEMENT.LOGIN],
    [ROLE.LIST]: [ELEMENT.SOCIAL_LOGIN],
    [ROLE.BUTTON]: [ELEMENT.REGISTER],
  },
} as TValidTestId;
